export default "__VITE_ASSET__h46tftq3__"